export default "__VITE_ASSET__COu9V_M8__"